<template>
  <div class="bc-invalid-link-container">
    <div class="expired-card">
      <div class="icon-container">
        <img
          class="icon"
          :src="require(`@/assets/images/icons/invalid-payment-link.svg`)"
          alt="Invalid Link Icon"
        />
      </div>
      <h1 class="title">{{ t.invalidLinkTitle }}</h1>
      <p class="description">
        {{ t.invalidLinkDescription }}
      </p>
    </div>
  </div>
</template>
<script>
import translations from "@/views/pages/digital-business-card/data/translations.js";

export default {
  name: "InvalidLink",
  props: {
    selectedLanguage: {
      type: String,
      required: true,
    },
  },
  computed: {
    t() {
      return translations[this.selectedLanguage] || translations.en;
    },
  },
};
</script>
<style lang="scss">
.bc-invalid-link-container {
  --color-title: #0090e7;
  --color-description: #6e6e6e;
  --color-icon: #dc3545;

  max-width: 90vw;
  margin: 0 auto;
  margin-top: 3rem;
  padding: 1.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Montserrat", sans-serif !important;
  .expired-card {
    max-width: calc(100% - 40px);
    padding: calc(1.5rem + 1px);
    text-align: center;
    .icon-container {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 15px;
      .icon {
        color: var(--color-icon);
        max-width: 25vw;
      }
    }
    .title {
      margin-top: 2rem;
      font-size: clamp(1.4rem, 6vw, 2rem);
      font-weight: 700 !important;
      margin-bottom: 1rem;
      color: var(--color-title);
    }
    .description {
      font-size: clamp(1.1rem, 5vw, 1.4rem);
      color: var(--color-description);
      margin-bottom: 2rem;
      font-weight: 700 !important;
    }
    /* Tablets and small desktops */
    @media (min-width: 768px) {
      .title {
        font-size: clamp(1.6rem, 4.5vw, 2.4rem);
      }
      .description {
        font-size: clamp(1.2rem, 4vw, 1.5rem);
      }
      .icon-container {
        .icon {
          max-width: 18vw;
        }
      }
    }
    /* Large desktops */
    @media (min-width: 1200px) {
      .title {
        font-size: clamp(1.6rem, 3vw, 2.5rem);
      }

      .description {
        font-size: clamp(1.2rem, 3vw, 1.6rem);
      }
      .icon-container {
        .icon {
          max-width: 15vw;
        }
      }
    }
  }
}
.dark-layout {
  .bc-invalid-link-container {
    --color-description: #a5a5a5;
  }
}
</style>
